import { z } from "zod"

export const createProfessorSchema = z.object({
  school_id: z.string().min(1, "required"),
  email: z.string().trim().min(1, "required").email("invalid_email"),
  name: z.string().trim().min(1, "required").max(120, "too_long"),
  full_name: z.string().trim().max(200, "too_long").optional(),
  semester: z.string().trim().max(20, "too_long").optional(),
})

export type CreateProfessorInput = z.infer<typeof createProfessorSchema>

// Edit drops school_id. Email is editable but is an identity change
// (the professor's SPA login) — the form warns + the backend re-invites
// (PRD-32 §FR-15).
export const editProfessorSchema = z.object({
  email: z.string().trim().min(1, "required").email("invalid_email"),
  name: z.string().trim().min(1, "required").max(120, "too_long"),
  full_name: z.string().trim().max(200, "too_long").optional(),
  semester: z.string().trim().max(20, "too_long").optional(),
})

export type EditProfessorInput = z.infer<typeof editProfessorSchema>
